import Vue from 'vue'
import toast from './index.vue'

const PopupBox = Vue.extend(toast)

toast.install = function (data) {

    let defaulData = {
        content: '提示',
        btn: [
            {   
                'event': ['closeEv'],
                'value': '关闭'
            },
        ],
    }

    data = Object.assign( defaulData, data)

    let instance = new PopupBox({
        data
    }).$mount()

    document.body.appendChild(instance.$el)
}

export default toast